import React from 'react';

export enum AttributeSelectorPlacement {
  PAGE = 'PAGE',
  POPUP = 'POPUP',
}

const ProductAttributesPlacementContext = React.createContext<AttributeSelectorPlacement>(
  AttributeSelectorPlacement.PAGE,
);

export default ProductAttributesPlacementContext;
